<template>
 <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Name</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
               <v-card-text>
                <v-form>
                 <v-text-field v-model="name" clearable :counter="50" label="Project Name" :error-messages="errors.collect('name')" v-validate="{required: true, min: 2, max: 50, regex: /^[\u0621-\u064Aa-zA-Z0-9 ]+$/}" data-vv-name="name" required append-icon="fa fa-code" color="red">
                  </v-text-field>

                  <!-- <v-text-field v-model="spec_length" clearable label="Project Length (m)" :error-messages="errors.collect('spec_length')" v-validate="{required: true, min_value: 0, max_value: max_spec_length}" data-vv-name="spec_length" type="number" required append-icon="fa fa-code" :hint="'Maximum length is ' + max_spec_length + ' meter'" data-vv-as="Project Length" color="red">
                  </v-text-field>  -->  

                  <!-- <v-text-field v-model="spec_width" clearable label="Project Width (m)" :error-messages="errors.collect('spec_width')" v-validate="{required: true, min_value: 0, max_value: max_spec_width}" data-vv-name="spec_width" type="number" required append-icon="fa fa-code" :hint="'Maximum width is ' + max_spec_width + ' meter'" data-vv-as="Project Width" color="red">
                  </v-text-field> -->

                  <!-- <v-text-field v-model="spec_height" clearable label="Project Height (m)" :error-messages="errors.collect('spec_height')" v-validate="{required: true, min_value: 0, max_value: max_spec_height}" data-vv-name="spec_height" type="number" required append-icon="fa fa-code" :hint="'Maximum height is ' + max_spec_height + ' meter'" data-vv-as="Project Height" color="red">
                  </v-text-field>

                  <v-text-field v-model="spec_weight" clearable label="Project Weight (kg)" :error-messages="errors.collect('spec_weight')"v-validate="{required: true, min_value: 0, max_value: max_spec_weight}" data-vv-name="spec_weight" type="number" required append-icon="fa fa-code" :hint="'Maximum weight is ' + max_spec_weight + ' kg'" data-vv-as="Project Weight" color="red">
                  </v-text-field> -->
                </v-form>
              <v-card-actions>
                 <v-btn color="primary" left @click.prevent="rollBack" >Previous</v-btn>
                <v-spacer></v-spacer>                
                <v-btn color="success"  :disabled="!! (errors.any() || isDisabled)" right @click.prevent="proceed">Next</v-btn>
              </v-card-actions>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>        
</template>
<script>
import NumberInputSpinner from '../../elements/Spinner.vue';
export default {
  props: ['user','items','original_items'],
  components: {
    NumberInputSpinner,
  },
  data (){
    return {
      spec_length: 0,
      spec_width: 0,
      // spec_height: 0,
      // spec_weight: 0,
      name: '',
      max_spec_width: (this.original_items.find(item => item.name == 'Booth Width').max_quantity),
      max_spec_length: (this.original_items.find(item => item.name == 'Booth Length').max_quantity),
      // max_spec_height: (this.original_items.find(item => item.name == 'Prototype Height').max_quantity),
      // max_spec_weight: (this.original_items.find(item => item.name == 'Prototype Weight').max_quantity),
    }
  },
  computed: {
    isDisabled(){
      if (this.name != '' && this.spec_length <= this.max_spec_length && this.spec_width <= this.max_spec_width) {
       return false;
      }
      return true;
    },
  },
  methods: {
   rollBack(){
      this.$emit('rollback',this.user)
    },
    proceed(){
      this.user.data.project = {spec_length: this.spec_length, spec_width: this.spec_width, name: this.name};

      let boothLengthItem = this.original_items.find(item => item.name == 'Booth Length').min_quantity;
      let boothWidthItem = this.original_items.find(item => item.name == 'Booth Width').min_quantity;
      // let boothHeightItem = this.original_items.find(item => item.name == 'Prototype Height').min_quantity;
      // let boothWeightItem = this.original_items.find(item => item.name == 'Prototype Weight').min_quantity;

      this.items.find(item => item.name == 'Booth Length').min_quantity = Math.max(boothLengthItem, Math.ceil(this.spec_length))
      this.items.find(item => item.name == 'Booth Width').min_quantity = Math.max(boothWidthItem, Math.ceil(this.spec_width))
      // this.items.find(item => item.name == 'Prototype Height').min_quantity = Math.max(boothHeightItem, Math.ceil(this.spec_height))
      // this.items.find(item => item.name == 'Prototype Weight').min_quantity = Math.max(boothWeightItem, Math.ceil(this.spec_weight))
      
      this.user.data.item_changed = false
      this.user.data.item_changed = true
      this.$emit('completed',this.user);
      if (this.user.data.members.filter(member => member.is_contact == true).length == 0) {
        this.$noty.info('Pay Attention!, You must choose one member as a contact person');
      }
    },       
  }
};
</script>
<style>
  
</style>



// WEBPACK FOOTER //
// src/components/Registeration/Project.vue